export default __webpack_public_path__ + "static/media/weather.7b7d0b9b.svg";